export const getCookieDomain = (stage) => {
    if (stage === 'local') {
        return 'localhost'
    }

    return stage === 'prod' ? 'pandora.hometree.co.uk' : `pandora.${stage}.hometree.co.uk`
}
